import script from "./CustomPropertiesEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomPropertiesEdit.vue?vue&type=script&setup=true&lang=ts"

import "./CustomPropertiesEdit.vue?vue&type=style&index=0&id=a18c3198&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a18c3198"]])

export default __exports__